/** ArtifactReviewState — shows whether artifact is in review queue and reviewer assignment */

import { useTranslation } from 'react-i18next'
import { User } from 'lucide-react'
import { cn } from '../../lib/utils'

interface Props {
  inQueue: boolean
  reviewerAssigned?: string | null
  isDark: boolean
}

export function ArtifactReviewState({ inQueue, reviewerAssigned, isDark }: Props) {
  const { t } = useTranslation('artifact')

  const rowClass = cn('flex items-center gap-2 py-1.5 text-xs')
  const labelClass = cn('w-32 shrink-0 font-medium', isDark ? 'text-neutral-400' : 'text-neutral-500')
  const valueClass = cn('flex-1', isDark ? 'text-neutral-200' : 'text-neutral-800')

  return (
    <section aria-label={t('reviewState.title')} className="space-y-3">
      <h3 className={cn('text-xs font-semibold uppercase tracking-wide', isDark ? 'text-neutral-400' : 'text-neutral-500')}>
        {t('reviewState.title')}
      </h3>

      <div className={cn('rounded-lg border p-3 space-y-0.5', isDark ? 'border-white/[0.06] bg-surface-2' : 'border-neutral-200 bg-neutral-50')}>
        {/* In queue */}
        <div className={rowClass}>
          <span className={labelClass}>{t('reviewState.inQueue')}</span>
          <span className={cn(valueClass, 'text-[11px]', inQueue ? 'text-brand-400' : '')}>
            {inQueue ? t('reviewState.yes') : t('reviewState.no')}
          </span>
        </div>

        {/* Reviewer */}
        <div className={rowClass}>
          <span className={labelClass}>
            <User className="inline h-3 w-3 mr-1 opacity-70" />
            {t('reviewState.reviewer')}
          </span>
          <span className={cn(valueClass, 'text-[11px]')}>
            {reviewerAssigned ?? t('reviewState.unassigned')}
          </span>
        </div>
      </div>
    </section>
  )
}
